import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'

const fb = require('../firebaseConfig.js')

Vue.use(Vuex)

// handle page reload
fb.auth.onAuthStateChanged(firebaseUser => {
    if (firebaseUser) {

        store.commit('setLoading', true)
        store.commit('setLoggedUser', {email: firebaseUser.email, userid: firebaseUser.uid})
        //store.dispatch('fetchUserProfile', this.state)
        //store.dispatch('fetchUserProfile')

        fb.usersCollection.doc(firebaseUser.uid).onSnapshot(doc => {
            store.commit('setUserProfile', doc.data())
        })

        // realtime updates from our posts collection
        fb.myCoursesCollection.where('userid', '==', firebaseUser.uid).orderBy('desired_date','desc').get().then(querySnapshot => {
    
                let myCoursesArray = []


                querySnapshot.forEach(doc => {
                    let selectedCourse = doc.data()
                    selectedCourse.docId = doc.id
                    myCoursesArray.push(selectedCourse)
                })

                store.commit('setMyCourses', myCoursesArray)
                store.commit('setLoading', false)

        }).catch(error => {
           store.commit('setError', error.message )
           store.commit('setLoading', false)
        })
    }
})


export const store = new Vuex.Store({
  state: {
    schedule: [],
    appTitle: 'FLLI Catalog',
    loggedUser: null,
    userProfile: null,
    myCourses: [],
    error: null,
    message: null,
    schedule: [],
    loading: false
  },
  mutations: {
     setLoggedUser (state, payload) {
       state.loggedUser = payload
     },
     setUserProfile(state, payload) {
       state.userProfile = payload
     },
     setError (state, payload) {
       state.error = payload
     },
     setMessage (state, payload) {
       state.message = payload
     },
     setLoading (state, payload) {
       state.loading = payload
     },
     setMyCourses(state, payload) {
            if (payload) {
                state.myCourses = payload
            } else {
                state.myCourses = []
            }
     },
     appendToMyCourses (state, payload) {
       state.myCourses.push(payload)
     }
  },
actions: {
 userSignUp ({commit}, payload) {
    commit('setLoading', true)
    fb.auth.createUserWithEmailAndPassword(payload.email, payload.password)
    .then(firebaseUser => {
       commit('setLoggedUser', {email: firebaseUser.user.email, userid: firebaseUser.user.uid})
       fb.usersCollection.doc(firebaseUser.user.uid).set({
          first_name: payload.first_name,
          last_name: payload.last_name,
          title: payload.title,
          company: payload.company,
          is_admin: false,
          phone: payload.phone
       }).then(()=> {
          store.dispatch('fetchUserProfile', this.state)
          commit('setLoading', false)
          router.push('/mycourses')
      }).catch(error => {
          commit('setError', error.message)
          commit('setLoading', false)
      })
    }).catch(error => {
     commit('setError', error.message)
     commit('setLoading', false)
    })
  },
  userUpdateProfile ({commit}, payload) {
    commit('setLoading', true)
    var user = fb.auth.currentUser
    fb.usersCollection.doc(user.uid).set({
          first_name: payload.first_name,
          last_name: payload.last_name,
          title: payload.title,
          company: payload.company,
          phone: payload.phone,
          is_admin: payload.is_admin
    }).then(()=> {

          // update email address
          user.updateEmail(payload.email).then(() => {
             this.state.loggedUser.email = payload.email
             store.dispatch('fetchUserProfile', this.state)
             commit('setMessage', 'Your profile updated successfully!')
             commit('setLoading', false)
          }).catch(function(error) {
             commit('setError', error.message)
             commit('setLoading', false)
          })

    }).catch(error => {
          commit('setError', error.message)
          commit('setLoading', false)
    })
  },
  submitFeedback ({commit}, payload) {
    commit('setLoading', true)
    fb.feedbackCollection.add({
          email: payload.email,
          full_name: payload.full_name,
          suggestion: payload.suggestion,
          rate: payload.rate,
          submitted_on: new Date()
    }).then(()=> {

      commit('setMessage', 'Your feedback submitted successfully!')
      commit('setLoading', false)

    }).catch(error => {
          commit('setError', error.message)
          commit('setLoading', false)
    })
  },
  userSignIn ({commit}, payload) {
    commit('setLoading', true)
    fb.auth.signInWithEmailAndPassword(payload.email, payload.password)
    .then(firebaseUser => {
      commit('setLoggedUser', {email: firebaseUser.user.email, userid: firebaseUser.user.uid})
      store.dispatch('fetchUserProfile', this.state)
      commit('setLoading', false)
      commit('setError', null)
      router.push('/mycourses')
    })
    .catch(error => {
      commit('setError', error.message)
      commit('setLoading', false)
    })
  },
  fetchUserProfile ({commit}, state ) {
        fb.usersCollection.doc(state.loggedUser.userid).get().then(res => {
            commit('setUserProfile', res.data())
        }).catch(error => {
           commit('setError', error.message )
        })
  },
  autoSignIn ({commit}, payload) {
      commit('setLoggedUser', {email: payload.email, userid: payload.uid})
      store.dispatch('fetchUserProfile', this.state)
  },
  userSignOut ({commit}) {
    fb.auth.signOut()
    commit('setLoggedUser', null)
    commit('setUserProfile', null)
    commit('setMyCourses', null)
    router.push('/signin')
  }
},
  getters: {
    isAdmin (state) {
      return state.loggedUser !== null && state.loggedUser !== undefined && state.userProfile !== null && state.userProfile !== undefined && state.userProfile.is_admin
    },
    isAuthenticated (state) {
      return state.loggedUser !== null && state.loggedUser !== undefined
    },
    isLoading (state) {
      return state.loading
    },
    signedInUserName (state) {
      if(state.userProfile !== null && state.userProfile !== undefined)
      {
          return state.userProfile.first_name + ' ' + state.userProfile.last_name
      }
      return 'not signed in' 
    },
    signedInUserId (state) {
      if(state.loggedUser !== null && state.loggedUser !== undefined)
      {
          return state.loggedUser.userid
      }
      return null 
    },
    signedInUserCourses (state) {
      if(state.loggedUser !== null && state.loggedUser !== undefined)
      {
          return state.myCourses
      }
      return [] 
   },
   allUsersCourses (state) {
    if(state.loggedUser !== null && state.loggedUser !== undefined)
    {

        // realtime updates from our posts collection
        fb.myCoursesCollection.get().then(querySnapshot => {
    
          let allMyCoursesArray = []


          querySnapshot.forEach(doc => {
              let selectedCourse = doc.data()
              selectedCourse.docId = doc.id
              allMyCoursesArray.push(selectedCourse)
          })


          store.commit('setLoading', false)

          return  allMyCoursesArray
  }).catch(error => {
     store.commit('setError', error.message )
     store.commit('setLoading', false)
  })


    }
    return [] 
  }
 }
})